import { DayOfWeek } from "../../c-types";
import { IProfile } from "../i-profile";
import { DateRangeType } from "./date-range-type.enum";
import { BitToDayOfWeekMapping, DaysOfWeek } from "./days-of-week.enum";
import { MonthEnum, MonthsOfYear, BitToMonthOfYearMapping } from "./months-of-year.enum";


//function can order all days by weekType or a selection of days(days of week) by WeekType
export function OrderByWeekType(
  ux: IProfile,
  weekType: DateRangeType,
  daysOfWeek?: DayOfWeek[] | number[] | number
): number[] {
  let updatedDaysOfWeek = new Array<number>();
  let weekStartDay: number;

  switch (weekType) {
    case DateRangeType.ScheduleWeek:
      weekStartDay = (ux?.endOfScheduleWeek ?? DayOfWeek.Saturday) + 1;
      break;
    case DateRangeType.TenantWeek:
      weekStartDay = (ux?.endOfWeek ?? DayOfWeek.Saturday) + 1;
      break;
    case DateRangeType.IVMRWeek:
      weekStartDay = (ux?.endOfIvmrWeek ?? DayOfWeek.Saturday) + 1;
      break;
    default: //DateRangeType.SettlementWeek
      weekStartDay = 6; //Fedex starts on Saturday
  }

  if (weekStartDay == 7) {
    weekStartDay = 0;
  }

  const day1 = weekStartDay;
  let day2 = day1 + 1;
  day2 %= 7;
  let day3 = day2 + 1;
  day3 %= 7;
  let day4 = day3 + 1;
  day4 %= 7;
  let day5 = day4 + 1;
  day5 %= 7;
  let day6 = day5 + 1;
  day6 %= 7;
  let day7 = day6 + 1;
  day7 %= 7;

  if (daysOfWeek == null || undefined) {
    updatedDaysOfWeek = [day1, day2, day3, day4, day5, day6, day7];
  } else if (!Array.isArray(daysOfWeek)) {
    const newDaysOfWeek = OnlyExpandDayOfWeek(daysOfWeek);
    ArrInput(newDaysOfWeek);
  } else {
    ArrInput(daysOfWeek);
  }

  function ArrInput(daysOfWeek: DayOfWeek[] | number[]) {
    const dayOrder = [day1, day2, day3, day4, day5, day6, day7];
    dayOrder.forEach((dayOrNo) => {
      daysOfWeek.forEach((dayNo) => {
        if (dayOrNo == dayNo) {
          updatedDaysOfWeek.push(dayNo);
        }
      });
    });
  }

  return updatedDaysOfWeek;
}

//expand from bitFlag if order doesn't matter
export function OnlyExpandDayOfWeek(bitNumber: number): number[] {
  const expandedDayOfWeek = new Array<number>();

  InternalExpand(DaysOfWeek.Sunday, bitNumber);
  InternalExpand(DaysOfWeek.Monday, bitNumber);
  InternalExpand(DaysOfWeek.Tuesday, bitNumber);
  InternalExpand(DaysOfWeek.Wednesday, bitNumber);
  InternalExpand(DaysOfWeek.Thursday, bitNumber);
  InternalExpand(DaysOfWeek.Friday, bitNumber);
  InternalExpand(DaysOfWeek.Saturday, bitNumber);

  function InternalExpand(daysOfWeek: DaysOfWeek, bitNumber: number) {
    const bitFlag = bitNumber & daysOfWeek;
    const dayOfWeek = BitToDayOfWeekMapping[daysOfWeek];
    if (bitFlag) {
      // should it be there
      if (expandedDayOfWeek.indexOf(dayOfWeek) < 0)
        // is it there
        expandedDayOfWeek.push(dayOfWeek); // add it
    } else {
      const currentIndex = expandedDayOfWeek.indexOf(dayOfWeek); // find it if it is there
      if (currentIndex >= 0)
        // is it there
        expandedDayOfWeek.splice(currentIndex, 1); //remove it
    }
  }

  return expandedDayOfWeek;
}

export function OnlyExpandMonthOfYear(bitNumber: number): number[] {
  const expandedMonthOfYear = new Array<number>();

  InternalExpand(MonthsOfYear.January, bitNumber);
  InternalExpand(MonthsOfYear.February, bitNumber);
  InternalExpand(MonthsOfYear.March, bitNumber);
  InternalExpand(MonthsOfYear.April, bitNumber);
  InternalExpand(MonthsOfYear.May, bitNumber);
  InternalExpand(MonthsOfYear.June, bitNumber);
  InternalExpand(MonthsOfYear.July, bitNumber);
  InternalExpand(MonthsOfYear.August, bitNumber);
  InternalExpand(MonthsOfYear.September, bitNumber);
  InternalExpand(MonthsOfYear.October, bitNumber);
  InternalExpand(MonthsOfYear.November, bitNumber);
  InternalExpand(MonthsOfYear.December, bitNumber);

  // Keeping OnlyExpandMonthOfYear consistent with OnlyExpandDayOfWeek
  function InternalExpand(monthsOfYear: MonthsOfYear, bitNumber: number) {
    const bitFlag = bitNumber & monthsOfYear;
    const monthOfYear = BitToMonthOfYearMapping[monthsOfYear];
    if (bitFlag != 0 && monthOfYear != MonthEnum.Invalid) {
      //should it be there
      if (expandedMonthOfYear.indexOf(monthOfYear) < 0)
        // is it there
        expandedMonthOfYear.push(monthOfYear); //add it
    } else {
      const currentIndex = expandedMonthOfYear.indexOf(monthOfYear); // find it if it is there
      if (currentIndex >= 0)
        // is it there
        expandedMonthOfYear.splice(currentIndex, 1); //remove it
    }
  }

  return expandedMonthOfYear;
}
